module.exports = __webpack_public_path__ + "img/layers-half.4dd0c77e.svg";